/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Container from "../../components/common/container/Container";
import {
  CREATE_REQ,
  DEBI_STATUS_LABEL,
  DEBI_ROLE,
  DEBI_REQUEST,
  SOURCE,
  COOKIE_KEY,
  DECRYPT_KEY,
  DEBOUNCE_STYLE,
} from "../../utils/constants/GlobalConstants";
import GridContainer from "../../components/common/grid/GridContainer";
import GridItem from "../../components/common/grid/GridItem";
import ButtonLayout from "../../components/common/button/ButtonLayout";
import DataTable from "../../components/common/dataTable/DataTable";
import DataList from "../../components/common/dataList/DataList";
import { useNavigate } from "react-router-dom";
import { DEBI_STATUS_LIST } from "../../utils/constants/GlobalFormConstants";
import SelectView from "../../components/common/selectView/SelectView";
import { useTheme, useMediaQuery } from "@mui/material";
import { ErrorBoundary } from "../../components/common/errorBoundary/ErrorBoundary";
import SimpleBackdrop from "../../components/common/backdrop/Backdrop";
import {
  getAllDebiList,
  getDebiList,
  getSearchedDebiList,
  getSearchedDebiListAll,
} from "../../services/debiServices";
import SimpleSnackbar from "../../components/common/snackbar/Snackbar";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { DebounceInput } from "react-debounce-input";

const Dashboard = () => {
  const [searchInput, setSearchInput] = useState("");
  const [source, setSource] = useState(SOURCE.MAIN);
  const [loader, setLoader] = useState(false);
  const [value, setValue] = useState("");
  const [apiError] = useState({ val: false, messages: "" });
  const [rows, setRows] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  const [pageNo, setPageNo] = useState(0);
  const [totalRows, setTotlRows] = useState(0);
  const [order, setOrder] = useState("");
  const [colName, setColName] = useState("");
  const [sourceChanged,setSourceChanged]=useState("")
  const navigate = useNavigate();
  const encryptF = Cookies.get(COOKIE_KEY);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const onPressNew = () => {
    navigate("/debi-tool/createdebi");
  };
  const getValue = (item) => {
    switch (item) {
      case DEBI_REQUEST.INCOMPLETE:
        return "Incomplete";
      case DEBI_REQUEST.PENDING:
        return "Pending";
      case DEBI_REQUEST.OPEN:
        return "Open";
      case DEBI_REQUEST.CANCELLED:
        return "Closed";
      case DEBI_REQUEST.HISTORY:
        return "History";
      default:
        return "Incomplete";
    }
  };
  const fetchDebiData = async () => {
    setLoader(true);
    try {
      let response;
      const val = getValue(value);
      if (val === "History") {
        let payload = {
          size: pageSize,
          page: isMobile ? pageNo > 0 ? pageNo-1 : pageNo : pageNo,
          sortColumn: colName ? colName : "modified",
          sortOrder: order ? order : "desc",
        };
        response = await getAllDebiList(payload);
      } else if (val === "Closed") {
        let payload = {
          size: pageSize,
          page: isMobile ? pageNo > 0 ? pageNo-1 : pageNo : pageNo,
          sortColumn: colName ? colName : "created",
          sortOrder: order ? order : "desc",
          status: val,
        };
        response = await getDebiList(payload);
      } else {
        let payload = {
          size: pageSize,
          page: isMobile ? pageNo > 0 ? pageNo-1 : pageNo : pageNo,
          sortColumn: colName ? colName : "modified",
          sortOrder: order ? order : "desc",
          status: val,
        };
        response = await getDebiList(payload);
      }
      setRows(response?.debiData);
      setTotlRows(response?.totalCount);
      setLoader(false);
    } catch (err) {
      setLoader(false);
      console.error(err);
    }
  };
  useEffect(() => {
    if (encryptF) {
      const bytes = CryptoJS.AES.decrypt(encryptF, DECRYPT_KEY);
      const decryptData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      const role = decryptData.group;
      setIsAdmin(
        role === DEBI_ROLE.SALES_REP || role === DEBI_ROLE.PARTS_ADMIN
      );
    }
  }, [encryptF]);
  useEffect(() => {
    if (pageNo >= 0 && pageSize !== 0 && order !== "" && colName !== "") {
      if (searchInput !== "") {
        handleSearch();
      } else {
        fetchDebiData();
      }
    } else if (pageNo > 0 && pageSize !== 0 && isMobile){
      if (searchInput !== "") {
        handleSearch();
      } else {
        fetchDebiData();
      }
    }
  }, [pageNo, pageSize, value, searchInput, order, colName]);

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const valSelectedFromDropDown = (item) => {
    setValue(item);
    setPageNo(0);
    setPageSize(5);
    setSearchInput("");
    let val = getValue(item);
    let colVal;
    if(val === "Closed")
    {
    colVal="created";
    }
    else{
      colVal = "modified"
    }
    setColName(colVal)
    setOrder("desc")
    if (
      item === DEBI_REQUEST.INCOMPLETE ||
      item === DEBI_REQUEST.PENDING ||
      item === DEBI_REQUEST.OPEN
    ) {
      setSource(SOURCE.MAIN);
    } else {
      setSource("main-" + item);
    }
    setSourceChanged(item);
  };
  const handleRowClick = async (row,index) => {
    
    navigate(`/debi-tool/details/${row.debiReg}`, {
      state: rows && rows[index]?.id,
    });
  };
  const onSortApicall = (order, orderBy) => {
    setOrder(order);
    setColName(orderBy);
    setPageNo(0);
    setPageSize(5);
  };
  const handleSearch = async () => {
    setLoader(true);
    try {
      if (searchInput !== "") {
        let response;
        const val = getValue(value);
        if (val === "History") {
          let payload = {
            searchCriteria: searchInput,
            sortColumn: colName ? colName : "modified",
            sortOrder: order ? order : "desc",
            page: isMobile ? pageNo > 0 ? pageNo-1 : pageNo : pageNo,
            size: pageSize,
          };
          response = await getSearchedDebiListAll(payload);
        } else {
          let payload = {
            status:val,
            searchCriteria: searchInput,
            sortColumn: colName ? colName : "modified",
            sortOrder: order ? order : "desc",
            page: isMobile ? pageNo > 0 ? pageNo-1 : pageNo : pageNo,
            size: pageSize,
          };
          response = await getSearchedDebiList(
            payload
          );
        }
        setRows(response?.debiData);
        setTotlRows(response?.totalCount);
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      console.error(err);
    }
  };
  const changePageNoAndSize = (page, rowsPerPage) => {
    setPageSize(rowsPerPage);
    setPageNo(page);
  };
  return (
    <>
      <SimpleBackdrop open={loader} />
      <ErrorBoundary>
        <Container breadCrumb={true} title={CREATE_REQ}>
          <div className="grid-actions">
            <GridContainer spacing={2}>
              <GridItem xs={12} sm={2.5} lg={2.5} md={2.5} xl={2.5}>
                <SelectView
                  data={DEBI_STATUS_LIST}
                  testid="select"
                  label={DEBI_STATUS_LABEL}
                  valSelectedFromDropDown={valSelectedFromDropDown}
                />
              </GridItem>
              <GridItem xs={12} sm={2.5} lg={2.5} md={2.5} xl={2.5}>
                <DebounceInput
                  className="main"
                  type={"text"}
                  placeholder={"Search DEBI's"}
                  value={searchInput}
                  testid="input"
                  style={DEBOUNCE_STYLE}
                  minLength={1}
                  debounceTimeout={1000}
                  onChange={handleSearchChange}
                />
              </GridItem>

              <GridItem xs={12} sm={7} lg={7} md={7} xl={7}>
                <div className="flex-container flex-right">
                  <ButtonLayout
                    testid="new"
                    color="primary"
                    disabled={!isAdmin}
                    label="New"
                    onClickBtn={() => onPressNew()}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </div>
          <div className="padding-m-b">
            {isMobile ? (
              <DataList
                source={source}
                searchedData={searchInput}
                rows={rows}
                onRowClick={handleRowClick}
                notShow={true}
                changePageNoAndSize={changePageNoAndSize}
                totalRows={totalRows}
                value={value}
              />
            ) : (
              <DataTable
                source={source}
                searchedData={searchInput}
                rows={rows}
                testid="table"
                onRowClick={handleRowClick}
                notShow={true}
                changePageNoAndSize={changePageNoAndSize}
                onSortApicall={onSortApicall}
                totalRows={totalRows}
                value={value}
                sourceChanged={sourceChanged}
              />
            )}
          </div>
        </Container>
        <SimpleSnackbar apiError={apiError} />
      </ErrorBoundary>
    </>
  );
};

export default Dashboard;
